import React from 'react';

interface RunwayWindArrowProps {
    angle: number;
    windSpeed: number;
    color?: string;
}

const RunwayWindArrow: React.FC<RunwayWindArrowProps> = ({ angle, windSpeed, color = 'orange' }) => (
    <g transform={`rotate(${angle} 500 500)`}>
        <polyline points={'500 300 460 260 460 220 540 220 540 260 500 300'} strokeWidth='3' stroke='black' fill={color} />
        <text fontWeight='bold' fill='black' x={480} y={265} fontSize={windSpeed < 10 ? 32 : 24} transform={`rotate(${-angle} 500 250)`}>
            {windSpeed}
        </text>
    </g>
);

export default RunwayWindArrow;
